import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

import { AdminRoutes } from './routes/AdminRoutes';
import { AuthRoutes } from './routes/AuthRoutes';
import { AdminSidebarWrapper } from './routes/SidebarWrapper/AdminSidebarWrapper';
import { StudentSidebarWrapper } from './routes/SidebarWrapper/StudentSidebarWrapper';
import { TeacherSidebarWrapper } from './routes/SidebarWrapper/TeacherSidebarWrapper';
import { StudentRoutes } from './routes/StudentRoutes';
import { TeacherRoutes } from './routes/TeacherRoutes';
import { EntryPageEnhanced as EntryPage } from './views/Auth/EntryPage.enhanced';

export const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<EntryPage />} />
          <Route path="auth/*" element={<AuthRoutes />} />
          <Route
            path="admin/*"
            element={
              <AdminSidebarWrapper>
                <AdminRoutes />
              </AdminSidebarWrapper>
            }
          />
          <Route
            path="student/*"
            element={
              <StudentSidebarWrapper>
                <StudentRoutes />
              </StudentSidebarWrapper>
            }
          />
          <Route
            path="teacher/*"
            element={
              <TeacherSidebarWrapper>
                <TeacherRoutes />
              </TeacherSidebarWrapper>
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};
